import { useState } from "react";
import "./ContactModal.css";
import ContactForm from "./ContactForm";

export default function ContactModal({ isOpen, onClose }) {
  const [showForm, setShowForm] = useState(false);

  if (!isOpen) return null;

  const handleSendMessage = () => {
    setShowForm(true);
  };

  const handleBookCall = () => {
    window.open("https://calendly.com/speak-with-simon/discovery-session", "_blank");
    onClose();
  };

  const handleBack = () => {
    setShowForm(false);
  };

  return (
    <div className="contact-modal-overlay" onClick={onClose}>
      <div className="contact-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="contact-modal-close" onClick={onClose}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 50 50"
            fill="#ffffff"
            width="24"
            height="24"
          >
            <path d="M 9.15625 6.3125 L 6.3125 9.15625 L 22.15625 25 L 6.21875 40.96875 L 9.03125 43.78125 L 25 27.84375 L 40.9375 43.78125 L 43.78125 40.9375 L 27.84375 25 L 43.6875 9.15625 L 40.84375 6.3125 L 25 22.15625 Z"></path>
          </svg>
        </button>

        {!showForm ? (
          <div className="contact-modal-options">
            <h2>How would you like to get in touch?</h2>
            <div className="contact-options-grid">
              <button
                className="contact-option-btn"
                onClick={handleSendMessage}
              >
                <div className="contact-option-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                    <polyline points="22,6 12,13 2,6"></polyline>
                  </svg>
                </div>
                <h3>Send a message</h3>
                <p>Fill out a form and we'll get back to you</p>
              </button>

              <button
                className="contact-option-btn"
                onClick={handleBookCall}
              >
                <div className="contact-option-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                    <line x1="16" y1="2" x2="16" y2="6"></line>
                    <line x1="8" y1="2" x2="8" y2="6"></line>
                    <line x1="3" y1="10" x2="21" y2="10"></line>
                  </svg>
                </div>
                <h3>Book a call</h3>
                <p>Schedule a discovery session with Simon</p>
              </button>
            </div>
          </div>
        ) : (
          <div className="contact-modal-form-container">
            <button className="contact-form-back" onClick={handleBack}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M19 12H5M12 19l-7-7 7-7"></path>
              </svg>
              Back
            </button>
            <ContactForm onSuccess={onClose} />
          </div>
        )}
      </div>
    </div>
  );
}

